import { Link } from "react-router-dom";

function Gauge({ percent, score, caption, label }) {
  const r = 44, c = 2 * Math.PI * r, off = c - (Math.min(100, Math.max(0, percent)) / 100) * c;
  return (
    <div data-testid="hero-performance-gauge" className="flex items-center gap-4 rounded-2xl bg-white/10 border border-white/15 px-5 py-4 shrink-0">
      <div className="relative w-28 h-28">
        <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
          <circle cx="50" cy="50" r={r} fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="8" />
          <circle cx="50" cy="50" r={r} fill="none" stroke="white" strokeWidth="8" strokeLinecap="round"
            strokeDasharray={c} strokeDashoffset={off} style={{ transition: "stroke-dashoffset 1s ease-out" }} />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span data-testid="hero-performance-score" className="text-2xl font-bold leading-none" style={{ fontFamily: "Outfit, sans-serif" }}>{score}</span>
          <span className="text-[10px] uppercase tracking-wider text-emerald-100 mt-1">puan</span>
        </div>
      </div>
      <div className="max-w-[150px]">
        <div className="text-sm font-semibold">{label}</div>
        <div data-testid="hero-performance-caption" className="text-xs text-emerald-100 mt-1 leading-relaxed">{caption}</div>
      </div>
    </div>
  );
}

export function WelcomeHero({ name, subtitle, actions = [], gauge, eyebrow = "Genel Bakış" }) {
  return (
    <section data-testid="welcome-hero" className="relative overflow-hidden rounded-3xl bg-emerald-700 text-white p-6 sm:p-8 shadow-[0_20px_40px_-20px_rgba(4,120,87,0.55)] animate-rise">
      <div aria-hidden className="absolute -right-24 -top-24 w-72 h-72 rounded-full bg-emerald-500/30" />
      <div aria-hidden className="absolute right-40 -bottom-32 w-64 h-64 rounded-full bg-emerald-900/30" />
      <div className="relative flex flex-col lg:flex-row lg:items-center justify-between gap-6">
        <div className="min-w-0">
          <div className="text-xs uppercase tracking-[0.18em] text-emerald-100 font-semibold mb-2">{eyebrow}</div>
          <h1 data-testid="welcome-title" className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
            Merhaba, {name}. <span className="text-emerald-100 font-semibold">Sizi görmek çok güzel.</span>
          </h1>
          {subtitle && <p className="text-emerald-50/90 text-sm sm:text-base mt-2 max-w-xl">{subtitle}</p>}
          {actions.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-5">
              {actions.map((a, i) => (
                <Link key={a.to} to={a.to} data-testid={a.testId}
                  className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-[background-color,transform] duration-200 hover:-translate-y-0.5 ${
                    i === 0 ? "bg-white text-emerald-800 hover:bg-emerald-50" : "bg-white/10 text-white border border-white/25 hover:bg-white/20"}`}>
                  <a.icon className="w-4 h-4" />{a.label}
                </Link>
              ))}
            </div>
          )}
        </div>
        {gauge && <Gauge {...gauge} />}
      </div>
    </section>
  );
}
